export default __webpack_public_path__ + "static/media/gallery_04.bface606.jpg";